import styled from "styled-components";

export const MainTemplates = styled.div`
  display: grid;
  width: 100vw;
  height: 100vh;
  grid-template-areas:
    "HD"
    "CT"
    "BN";
  grid-template-rows: 56px auto 70px;
  background: ${(props) => props.theme.colors.mainBg};
`;

export const ContentNavigation = styled.section`
  width: 100%;
  height: 60px;
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
`;

export const ContentsSection = styled.section<any>`
  grid-area: CT;
  overflow-y: auto;
  display: flex;
  padding: ${(props) => (props.padding ? props.padding : "16px")};
  flex-direction: column;
  gap: ${(props) => (props.gap ? props.gap : "40px")};
`;
